<mat-card class="metric-card" [ngClass]="cardColorClass">
  <div class="metric-card-content">
    <div class="metric-header">
      <div class="metric-icon-wrapper" *ngIf="icon">
        <mat-icon class="metric-icon">{{ icon }}</mat-icon>
      </div>
      <div class="metric-text">
        <h3 class="metric-title">{{ title }}</h3>
        <p class="metric-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
      </div>
    </div>
    
    <div class="metric-value-section">
      <div class="metric-value" *ngIf="!loading">
        {{ value }}
      </div>
      <mat-progress-spinner 
        *ngIf="loading" 
        mode="indeterminate" 
        diameter="40">
      </mat-progress-spinner>
      
      <div class="metric-trend" *ngIf="trendValue && !loading" [ngClass]="trendColorClass">
        <mat-icon class="trend-icon">{{ trendIcon }}</mat-icon>
        <span class="trend-value">{{ trendValue }}</span>
      </div>
    </div>
  </div>
</mat-card>